import React, { useEffect, useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  Menu,
  FormControl,
  InputLabel,
  Button,
  Grid,
  Stack,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Vertical from "../../../../styles/svg/vertical-ll55.svg";
import UploadSurvey from "../../../../styles/svg/upload-survey.svg";
import useCustomForm from "../../../../hooks/useForm";
import PrimaryButton from "../../../../components/Button/Button";
import InputFileUpload from "../../../LeadCompliance/components/Header/UploadButton";
// import { fields, surveyDetailsFields } from "./SurveyFields";
import useCustomMutate from "../../../../hooks/useMutate";
import {
  addSurveyCompliance,
  scanSurveyCompliance,
} from "../../../../sevices/leadComplianceApi";
import { getBuildingBySurvey } from "../../../../sevices/buildingApi";
import { debounce, isString } from "lodash";
import CustomDatePicker from "../../../../components/DatePickerNew";
import moment from "moment";
import {
  deFormatPhoneNumber,
  formatPhoneNumber,
} from "../../../../utils/helpers";
import SignatureForm from "../../../SurveyScan/SignatureForm";
import CustomSelectDropdown from "../../../Client/components/DropDownFilter";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import { getLL55SurveyDetails, scanLl55SurveyCompliance, updateLL55SurveyResponse } from "../../../../sevices/ll55Api";
import QuestionListItem from "./QuestionListItem";
import { surveyDetailsFields, surveyFields } from "./fields";

function EnterSurveyForm({
  initialData = {},
  onClose,
  isShow = false,
  isFromQr = false,
  token = "",
}) {
  const [isAlreadySubmitted, setFormState] = useState("");
  const [message, setMessage] = useState(
    "This Survey response has already been submitted."
  );
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleReset,
    setValue,
    watch,
    setError,
    clearErrors,
    isValid,
    getValues,
    reset,
    trigger,
  } = useCustomForm(initialData);
  const { mutate } = useCustomMutate(
    isFromQr ? scanLl55SurveyCompliance : updateLL55SurveyResponse,
    [],
    () => {
      setFormState(true);
      onClose?.();
      setMessage("This survey response has been submitted.");
    }
  );

  const [survey, setSurvey] = useState(initialData?.survey_id || "");
  const [surveyError, setSurveyError] = useState("");
  const [isRequiredUpload, setIsRequiredUpload] = useState(true);
  const [data, setData] = useState({});
  const [clearFormData, setClearFormData] = useState(false);
  const [loading, setLoading] = useState(false);

  const disableSubmitForm = () => {
    const {
      ll55_visible_cockroaches_report = false,
      ll55_visible_mices_and_rates_report = false,
      ll55_visible_mold_report = false,
    } = data || {};

    return (
      ll55_visible_cockroaches_report ||
      ll55_visible_mices_and_rates_report ||
      ll55_visible_mold_report
    );
  };

  useEffect(() => {
    const getSurvey = debounce(() => {
      getLL55SurveyDetails(survey, token)
        .then((res) => {
          setIsRequiredUpload(!res?.data?.data?.response_data?.survey_exist);
          setData(res?.data?.data?.response_data?.ll55_compliance);
          isFromQr &&
            setFormState(res?.data?.data?.response_data?.survey_exist);
          !isFromQr
            ? reset({
                ...res?.data?.data?.response_data?.ll55_compliance,
                dates: res?.data?.data?.response_data?.ll55_compliance
                  ?.response_date
                  ? new Date(
                      res?.data?.data?.response_data?.ll55_compliance?.response_date
                    )
                  : new Date(),
                building_address:
                  res?.data?.data?.response_data?.building_address,
              })
            : setValue(
                "building_address",
                res?.data?.data?.response_data?.building_address
              );
        })

        .catch((err) => {
          isFromQr || setError("survey_id", err?.response?.data?.message);
          isFromQr || setSurveyError(err?.response?.data?.message);
        });
    }, 700);

    if (survey) {
      survey && setSurveyError("");
      survey && clearErrors("survey_id");
      getSurvey();
    } else {
      setError("survey_id", "Survey Id is Required");
      setSurveyError("Survey Id is Required");
    }

    return () => {
      // Cleanup the debounce function on component unmount
      survey && setSurveyError("");
      survey && clearErrors("survey_id");
      setValue("building_address", "");
      getSurvey.cancel();
    };
  }, [survey]);

  const handleChange = (e) => {
    setSurvey(e.target.value);
  };

  const submit = (data) => {
    const payload = Object.fromEntries(
      Object.entries(data).filter(([key, value]) => value !== null)
    );

    delete payload.building_address;
    const attachment = data?.attachment?.[0];
    delete payload?.attachment;
    mutate({
      data: {
        ...payload,
        ...(attachment
          ? {
              attachment: attachment,
            }
          : {}),
        survey_id: survey,
      },
      survey_id: survey,
      token,
    });
  };

  const handleDeleteFile = (e, isString) => {
    e.preventDefault();
    e.stopPropagation();
    isString ? setClearFormData(true) : setValue("attachment", []);
  };

  const DeleteFormData = () => {
    mutate({
      data: {
        survey_id: survey,
        is_delete: true,
      },
    });
  };

  return (
    <div className="survey-form-container">
      {clearFormData && (
        <ConfirmationDialog
          open={clearFormData}
          handleClose={() => setClearFormData(false)}
          message={
            "Are you sure you want to delete this survey response? This will also delete any reports you have uploaded for this unit. This action cannot be undone."
          }
          callback={DeleteFormData}
          loading={loading}
          btnTitle={"Delete"}
          title={"⚠️ Confirm Deletion"}
          btnColor="var(--dark-light-error, #B71D18)"
        />
      )}
      {isAlreadySubmitted ? (
        <div className="loader-center">
          <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
            <p>{message}</p>
            <p>
              {message == "This survey response has been submitted."
                ? "Esta respuesta de la encuesta ha sido enviada."
                : "Esta respuesta a la encuesta ya ha sido enviada."}
            </p>
          </Alert>
        </div>
      ) : (
        <form onSubmit={handleSubmit(submit)}>
          <Stack>
            <Grid container spacing={4}>
              {!isFromQr && (
                <Grid item xs={12} md={4} className="d-flex align-items-center">
                  <p className="label-field">Survey ID:</p>
                  {isShow ? (
                    <p className="survey-id-text">{initialData?.survey_id}</p>
                  ) : (
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      error={!!surveyError}
                      helperText={surveyError}
                      defaultValue={initialData?.survey_id}
                      onChange={handleChange}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": {
                            borderColor: "#16304f", // Change this to your desired focus color
                          },
                        },
                        "& .MuiInputLabel-root": {
                          "&.Mui-focused": {
                            color: "#16304f", // Change this to your desired label focus color
                            fontFamily: "segoe_uisemibold",
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  )}
                </Grid>
              )}
              <Grid
                item
                xs={12}
                md={isFromQr || isShow ? 8 : 5}
                className="d-flex align-items-center"
              >
                <p className="label-field">Address:</p>
                <p className="survey-id-text">
                  {watch("building_address") || ""}
                </p>
              </Grid>
              {!isFromQr && !isShow && (
                <Grid
                  item
                  xs={12}
                  md={3}
                  className="d-flex justify-content-end align-items-center"
                >
                  <InputFileUpload
                    watch={watch}
                    register={register}
                    getValues={getValues}
                    errors={errors}
                    isRequiredUpload={isRequiredUpload}
                    attachmentName={isString(watch("attachment"))}
                    onDelete={handleDeleteFile}
                  />
                </Grid>
              )}
            </Grid>
            {disableSubmitForm() && (
              <p style={{ color: "red" }} className="mt-4">
                You cannot edit this survey because the report has already been
                uploaded.
              </p>
            )}
            <Grid className="d-flex mt-4">
              {!isFromQr && (
                <div className="verticle-div mr-32">
                  <img src={Vertical} />
                </div>
              )}
              <div className="horizontal-div w-100">
                <div className="d-flex select-field-container">
                  <div className="mr-2">
                    <label class="custom-checkbox-large">
                      <input
                        type="checkbox"
                        disabled={isShow}
                        {...register("no_findings")}
                      />
                      <span class="checkmark-large"></span>
                    </label>
                  </div>
                  <div>
                    <p className="question-title-blue-text">No Findings</p>
                    <p className="question-text">
                      This unit has had no findings of Mold, pest and other
                      Asthma Allergen Triggers at the time of inspection
                    </p>
                  </div>
                </div>

                {surveyFields.map((field, idx) => (
                  <QuestionListItem
                    key={field.name}
                    field={field}
                    index={idx}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                  />
                ))}

               
              </div>
            </Grid>
            <Grid container spacing={4}>
              {surveyDetailsFields
                // .filter((el) => (isFromQr ? el.name !== "response_type" : true))
                .map((el, idx) => (
                  <Grid
                    item
                    xs={12}
                    md={isFromQr ? 6 : el.size}
                    className="d-flex align-items-center"
                    key={`survey-details-fields-${idx}`}
                  >
                    <p className="label-field">{el.label}</p>
                    {el.type == "date" ? (
                      <CustomDatePicker
                        value={watch(el.name)}
                        defaultValue={initialData[el.name] || ""}
                        errors={errors}
                        // disabled={true}
                        field={el}
                        setValue={setValue}
                        {...register(el.name, {
                          required: `${el.label} is required`,
                        })}
                        // isShring={true}
                        // placeholder={el.placeholder}
                      />
                    ): (
                      <TextField
                        fullWidth
                        {...register(
                          el.name,
                          isFromQr && {
                            required: `${el.label} is required`,
                          }
                        )}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors[el.name]}
                        helperText={errors[el.name]?.message}
                        disabled={isShow}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "#16304f", // Change this to your desired focus color
                            },
                          },
                          "& .MuiInputLabel-root": {
                            "&.Mui-focused": {
                              color: "#16304f", // Change this to your desired label focus color
                              fontFamily: "segoe_uisemibold",
                              fontSize: "13px",
                            },
                          },
                        }}
                      />
                    )}
                  </Grid>
                ))}
            </Grid>
            {isFromQr && (
              <SignatureForm
                setValue={setValue}
                setError={setError}
                clearErrors={clearErrors}
                register={register}
                errors={errors}
              />
            )}

            {!isShow ? (
              <Stack
                sx={{
                  alignSelf: "end",
                }}
                direction={"row"}
                spacing={2}
                className="popup-footer-border"
              >
                <Button
                  variant="outlined"
                  className="secondary-btn-class"
                  onClick={onClose}
                  // disabled={loading}
                >
                  Cancel
                </Button>
                {/* //capitalize h-42 */}
                <Button
                  type="submit"
                  variant="contained"
                  className={disableSubmitForm() ? "" : "primary-btn-class"}
                  disabled={disableSubmitForm()}
                  sx={{ boxShadow: "none" }}
                >
                  Submit
                </Button>
              </Stack>
            ) : (
              <div className="mt-4"></div>
            )}
          </Stack>
        </form>
      )}
    </div>
  );
}

export default EnterSurveyForm;
